<script>
import financeMixin from '@mixins/financeMixin'

export default {
  mixins: [financeMixin],
  props: {
    invoiceSummaryData: {
      type: Object,
      required: true,
    },
  },
}
</script>

<template>
  <v-card id="invoice-sum-panel" class="cl-elevation rounded-xl">
    <v-card-text>
      <strong>
        {{ $t('finance.invoiceViewSummaryTotalTitle') }}-{{ displayGSTtext() }})
      </strong>
      <div>
        {{ displayCurrency(invoiceSummaryData.exGSTAmount) }}
      </div>

      <strong>{{ $t('finance.invoiceViewGSTTitle') }} </strong>
      <div>
        {{ displayCurrency(invoiceSummaryData.taxAmount) }}
      </div>
      <div id="invoice-view-total">
        <strong>
          {{ $t('finance.invoiceViewSummaryTotalWithTaxTitle') }}-{{
            displayGSTtext()
          }})</strong
        >
        <div>
          {{ countDisplayTotal(invoiceSummaryData) }}
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<style lang="scss">
@import '@styles';
.c-subTitle {
  font-size: 1.1em;
}
#invoice-sum-panel {
  text-align: right;
}
</style>
